import PropTypes from 'prop-types';

const Calendar2 = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_83260_67022)">
      <path
        d="M10.9375 1.75H3.0625C2.33763 1.75 1.75 2.33763 1.75 3.0625V10.9375C1.75 11.6624 2.33763 12.25 3.0625 12.25H10.9375C11.6624 12.25 12.25 11.6624 12.25 10.9375V3.0625C12.25 2.33763 11.6624 1.75 10.9375 1.75Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9375 1.75H3.0625C2.33763 1.75 1.75 2.33763 1.75 3.0625V5H12.25V3.0625C12.25 2.33763 11.6624 1.75 10.9375 1.75Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 1L9.625 2.625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 1L4.375 2.625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_83260_67022">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Calendar2;
